import {createStore} from '../alt';

import SingleObjectResource, {InvalidResponseCode} from '../resources/GenericResource';
import CurrentUserActions from '../actions/CurrentUserActions';
import RecommendationLetterActions from '../actions/RecommendationLetterActions';


const RecommendationLetterSource = {

    getRecommendationLetters() {
        return {
            remote(state, candidateId) {
                const query = '?candidate_id=' + candidateId;
                return new SingleObjectResource(DJ_CONST.API.recommendationletterList + query).fetch();
            },

            success: RecommendationLetterActions.getRecommendationLettersSuccess,
            error: CurrentUserActions.pageFault
        }
    }
};

class RecommendationLetterStore {
    constructor() {
        this.recommendation_letters = [];
        this.exportAsync(RecommendationLetterSource);
        this.bindActions(RecommendationLetterActions);
    }

    onGetRecommendationLettersSuccess(recommendation_letters) {
        this.setState({recommendation_letters})
    }
}

export default createStore(RecommendationLetterStore, 'RecommendationLetterStore', module);



/** WEBPACK FOOTER **
 ** ./app/src/stores/RecommendationLetterStore.js
 **/